<template>
  <div class>
    <div class="d-flex justify-content-center"  :class="isSushi && 'montserrat-500'">
      <div class="col-12">
        <form class="pt-2 pb-4 d-flex flex-wrap justify-content-center" @submit.prevent="register">
          <h3
            class="w-75 mt-3 mb-5 d-flex justify-content-center"
          >{{ $t("message.createYourAccount") }}</h3>
          <div class="form-group w-75">
            <label for="email">{{ $t("message.emailAddress") }} <span class="required-logo">*</span> </label>
            <input
              id="EmailId"
              v-model="email"
              v-validate="'required|email'"
              type="email"
              name="email"
              class="form-control"
              aria-describedby="emailHelp"
              ref="emailAddress"
            />
            <div class="invalid-feedback">{{ OOErrors.first("email") | inputNameLocale("email") }}</div>
          </div>
         <div class="form-group w-75">
            <label for="Confirm Password">
              {{
              $t("message.confirmEmail")
              }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="ConfirmEmailId"
              v-model="confirmEmail"
              type="email"
              name="confirmEmail"
              v-validate="'required|confirmed:emailAddress'"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{
              OOErrors.first("confirmEmail")
              | inputNameLocale("confirmEmail")
              }}
            </div>
          </div>
          <div class="form-group w-75">
            <label for="First Name">{{ $t("message.firstName") }} <span class="required-logo">*</span></label>
            <input
              v-validate="'required|min:2|alpha'"
              id="FirstName"
              v-model="firstName"
              name="firstName"
              type="text"
              class="form-control"
            />
            <div
              class="invalid-feedback"
            >{{ OOErrors.first("firstName") | inputNameLocale("firstName") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="Last Name">{{ $t("message.lastName") }} <span class="required-logo">*</span></label>
            <input
              v-validate="'required|min:2|alpha'"
              id="LastName"
              v-model="lastName"
              name="lastName"
              type="text"
              class="form-control"
            />
            <div
              class="invalid-feedback"
            >{{ OOErrors.first("lastName") | inputNameLocale("lastName") }}</div>
          </div>
          <div v-if="googleLoaded" class="form-group w-75">
            <label for="address">{{ $t("message.address") }}</label>
            <vue-google-autocomplete
              id="OO_registeraddressinput"
              name="OO_registeraddressinput"
              ref="gAutoComplete"
              :enable-geolocation="true"
              class="form-control"
              @change="setAddress"
              :country="['au']"
              :placeholder="getStartTypingPlaceholder"
            />
            <div
              class="invalid-feedback"
            >{{ OOErrors.first("address") | inputNameLocale("address") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="Phone Number">{{ $t("message.phoneNumber") }} <span class="required-logo">*</span></label>
            <input
              v-validate="{ required: true, min: 8, regex: this.getRegex(), max: this.getMax()}"
              id="PhoneNumber"
              v-model="phoneNumber"
              name="phoneNumber"
              type="text"
              class="form-control"
            />
            <div
              class="invalid-feedback"
            >{{ OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber") }}</div>
          </div>

          <div class="form-group w-75">
            <label for="birth Date">{{ $t("message.birthDate") }} <span class="required-logo">*</span></label>
             <date-pick id="BirthDate"
              name="birthDate"
              v-model="birthDate"
              :format="'DD/MM/YYYY'"
              :inputAttributes="{placeholder:'DD/MM/YYYY', class: ['form-control', bdstatus] }"
              @input="isValidDate($event)"
              :parseDate="parseDate"
              ></date-pick>
               <span v-if="birthDatestatus != 0" class="invalid-feedback" style="display: block;">{{birthDatestatus == 1 ?"The Date of Birth field is required":"The Date of Birth should be DD/MM/YYYY format" }}</span>
            <div
              class="invalid-feedback"
            >{{ OOErrors.first("birthDate") | inputNameLocale("birthDate") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="password">{{ $t("message.password") }} <span class="required-logo">*</span></label>
            <input
              id="passwordId"
              v-model="password"
              type="password"
              name="password"
              v-validate="'required|min:6'"
              class="form-control"
              ref="password"
              autocomplete="new-password"
            />
            <div
              class="invalid-feedback"
            >{{ OOErrors.first("password") | inputNameLocale("password") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="Confirm Password">
              {{
              $t("message.confirmPassword")
              }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="ConfirmPasswordId"
              v-model="confirmPassword"
              type="password"
              name="confirmPassword"
              v-validate="'required|confirmed:password'"
              class="form-control"
            />
            <div class="invalid-feedback">
              {{
              OOErrors.first("confirmPassword")
              | inputNameLocale("confirmPassword")
              }}
            </div>
          </div>

          <div class="w-75 mt-4 justify-content-center">
            <p
              style="font-size:0.6875rem;line-height: 1.4;text-align: center;"
            >
              {{$t('message.byContinuingYouAgreeToOur')}}
              <a href="#" @click.prevent="termsClick()">
                <b>
                  {{$t('message.termsOfUsePrivacyStatement')}}
                </b>
              </a>
            </p>
          </div>

          <div class="w-75 mt-3">
            <button
              :disabled="loading"
              :style="desktopStyles.btn"
              type="submit"
              class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
              :class="isSushi && 'background-sushi'"
            >
              {{ $t("message.register") }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div class="w-75 mt-4 d-flex justify-content-center">
            {{ $t("message.alreadyHaveProfile") }} ?&nbsp;
            <a
              href="#"
              :style="desktopStyles.LinkColorTxt"
              @click="$emit('show-login')"
            >{{ $t("message.signIn") }}</a>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
          <div v-if="FacebookLogin || GoogleLogin" class="w-75 my-4 d-flex justify-content-center">
            <strong>{{ $t("message.or") }}</strong>
          </div>
          <div class="container">
            <div class="row mb-4 justify-content-center">
              <auth-providers-login @close-overlay="$emit('close-overlay')" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <termsAndConditionsModal v-if="showModal" @close-modal="closeModal" />
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import shared from "../../sharedscripts/user/register.js";
import login from "../../sharedscripts/user/login.js";
import AuthProvidersLogin from "./AuthProvidersLogin";
import { mapGetters } from "vuex";
import { $$ } from "./../../sharedscripts/OO_jquery";
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import termsAndConditionsModal from "../shop/partials/termsAndConditionsModal.vue";


export default {
  components: {
    AuthProvidersLogin,
    VueGoogleAutocomplete,
    DatePick,
    termsAndConditionsModal
  },
  props: {
    storeid: {
      type: String,
      default: null
    },
    forgift: {
      type: Boolean,
      default: false
    },
    showedindrawer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      confirmEmail: "",
      phoneNumber: "",
      password: "",
      birthDate: "",
      confirmPassword: "",
      loading: false,
      address: "",
      error: "",
      googleLoaded: false,
      birthDatestatus:0,
      showModal: false
    };
  },
  updated() {
    if (this.$refs.gAutoComplete) {
      this.$refs.gAutoComplete.$refs.autocomplete.autocomplete = "none";
    }
    if (this.address) {
      document.getElementById("OO_registeraddressinput").value = this.address;
    }
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "viewConfig", "currentStoreDoc", "hqDoc"]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    },
    getStartTypingPlaceholder(){
      return this.$t("message.StartTyping");
    },
    bdstatus(){
      return this.birthDatestatus!=0 ? 'invaliddatetime':'';
    },
    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },
  mounted() {
    this.setStoreLoaded();
    shared.mounted(true, this);
    $$('#drawer').on('touchstart', this.autocompleteblur);
    $$("#drawer").on('scroll', this.autocompleteblur);
  },
  methods: {
    ...shared.methods,
    ...login.methods,
    autocompleteblur(){
      $$('#OO_registeraddressinput').blur();
    },
    parseDate(dateString) {
        var date = dateString.split("/");
          if((date[0] && date[0].length > 0) && (date[1] && date[1].length > 0) && (date[2] && date[2].length == 4))
          {
            return new Date(date[2], date[1] - 1, date[0]);
          }
          else
          {
            return undefined;
          }

      },
      closeModal() {
        this.showModal = false;
      },
      termsClick(){
        if(this.showedindrawer)
        {
          this.$emit('show-term');
        }else
        {
          this.showModal = true;
        }
      }
  },
  watch: {
    address() {
      document.getElementById("drawer").style.overflow = "auto";
      document.body.style.overflow = "auto";
    },
  },
};
</script>
<style scoped>
.required-logo {
  color: red;
}
.vdpComponent{
  display: block;
}
</style>
